'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'OwnershipFormRestService',
    function($modal, OwnershipFormRestService) {
        return {
            select: select,
            create: create,
            edit: edit,
            api: OwnershipFormRestService,
        };

        function select(ownershipForm, filters, def) {
            return $modal.open({
                template: require('../view/ownership-form-modal-select.html'),
                controller: 'OwnershipFormModalSelectController',
                size: 'lg',
                backdrop: false,
                resolve: {
                    ownershipForm: function() {
                        return ownershipForm;
                    },
                    ownershipFormFilters: function() {
                        return filters != null ? filters : [];
                    },
                    def: () => {
                        return {
                            org: def.org,
                        };
                    },
                },
            });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/ownership-form-modal-create.html'),
                controller: 'OwnershipFormModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    ownershipForm: function() {
                        return {
                            org: (function(def) {
                                if (def != null && def.org != null) {
                                    return def.org;
                                }
                            })(def),
                        };
                    },
                },
            });
        }

        function edit(ownershipForm) {
            return $modal.open({
                template: require('../view/ownership-form-modal-create.html'),
                controller: 'OwnershipFormModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    ownershipForm: function() {
                        return ownershipForm;
                    },
                },
            });
        }
    }];
